let telegramMiniAppAuthPromise = null;
let lastTelegramInitData = '';

const TELEGRAM_HASH_PREFIX = 'tgWebApp';

const getHashParams = () => {
  const hashValue = window.location.hash.replace(/^#/, '').trim();
  return new URLSearchParams(hashValue);
};

export const getTelegramMiniApp = () => window.Telegram?.WebApp || null;

export const getTelegramMiniAppInitData = () => {
  const webApp = getTelegramMiniApp();
  if (webApp?.initData) {
    return webApp.initData;
  }

  return getHashParams().get('tgWebAppData') || '';
};

export const isTelegramMiniAppSession = () => Boolean(getTelegramMiniAppInitData());

export const prepareTelegramMiniApp = () => {
  const webApp = getTelegramMiniApp();
  if (!webApp) {
    return;
  }

  try {
    webApp.ready();
    webApp.expand();
  } catch (error) {
    console.warn('[telegram-miniapp] Failed to initialize Telegram WebApp shell', error);
  }
};

export const clearTelegramMiniAppLaunchParams = () => {
  const hashParams = getHashParams();
  const telegramKeys = Array.from(hashParams.keys()).filter((key) => key.startsWith(TELEGRAM_HASH_PREFIX));

  if (telegramKeys.length === 0) {
    return;
  }

  telegramKeys.forEach((key) => hashParams.delete(key));

  const nextHash = hashParams.toString();
  const nextUrl = `${window.location.pathname}${window.location.search}${nextHash ? `#${nextHash}` : ''}`;
  window.history.replaceState({}, document.title, nextUrl);
};

export const authenticateTelegramMiniApp = async (axiosInstance) => {
  const initData = getTelegramMiniAppInitData();
  if (!initData) {
    return null;
  }

  if (telegramMiniAppAuthPromise && lastTelegramInitData === initData) {
    return telegramMiniAppAuthPromise;
  }

  lastTelegramInitData = initData;
  telegramMiniAppAuthPromise = axiosInstance.post('/auth/telegram-miniapp', { initData });

  try {
    return await telegramMiniAppAuthPromise;
  } finally {
    telegramMiniAppAuthPromise = null;
  }
};
